import { render } from "./Mo_addchg_row.vue?vue&type=template&id=63383d94&scoped=true&ts=true"
import script from "./Mo_addchg_row.vue?vue&type=script&lang=ts"
export * from "./Mo_addchg_row.vue?vue&type=script&lang=ts"

import "./Mo_addchg_row.vue?vue&type=style&index=0&id=63383d94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63383d94"]])

export default __exports__